export default (value)=> { return value & 1; }